import { QueryBuilderBootstrap } from "@react-querybuilder/bootstrap";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import { add, QueryBuilder } from "react-querybuilder";
import { connect } from "react-redux";
import { Card, CardBody } from "reactstrap";
import CustomCombinator from "./CustomCombinator";
import CustomValueEditor from "./CustomValueEditor";

import {
  apiQueryBuilderApiErrorAction,
  getQueryBuilderProfileFilterListAction,
} from "../../../store/actions";

import { get as getRuleValuesFromApi } from "../../../helpers/api_helper/ApiHelpers/apiHelpers";

const initialQuery = {
  combinator: "and",
  rules: [],
};

class RavenQueryBuilder extends Component {
  isLoadigContinue = Number.MAX_VALUE;
  profileListReady = false;
  IsQueryUpd = true;
  constructor(props) {
    super(props);
    this.state = {
      fields: [],
      query: initialQuery,
      profileFilterList: [],
    };

    this.addRule = this.addRule.bind(this);
    this.setQuery = this.setQuery.bind(this);
    this.getInitializeQuery = this.getInitializeQuery.bind(this);
    this.getDynamicFieldValues = this.getDynamicFieldValues.bind(this);
    this.getRuleComboValues = this.getRuleComboValues.bind(this);
    this.setDynamicValues = this.setDynamicValues.bind(this);
    this.getUserIterfaceData = this.getUserIterfaceData.bind(this);
    this.isExistQuery = this.isExistQuery.bind(this);
  }

  //#region Base Operations
  async componentDidMount() {
    this.props.apiError("");

    const { profileGroupGuid, profileFilterList, onGetProfileFilterList } =
      this.props;

    if (profileFilterList) {
      await onGetProfileFilterList(profileGroupGuid);
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { profileFilterList } = this.props;

    if (
      prevProps.profileFilterList !== profileFilterList &&
      this.IsQueryUpd === true
    ) {
      this.profileListReady = true;
      this.setQuery(initialQuery);
      this.IsQueryUpd = false;
      this.getDynamicFieldValues(profileFilterList);

      if (this.props.initializeQuery && this.props.profileGroupGuid)
        this.setQuery(this.getInitializeQuery());
    }
  }
  //#endregion

  getInitializeQuery() {
    let query;
    if (this.props.initializeQuery != undefined || this.props.initializeQuery != "") {
      if (this.props.initializeQuery && this.props.profileGroupGuid) {
        if (this.props.initializeQuery.length > 1) {
          query = JSON.parse(this.props.initializeQuery);
        }
        else {
          query = "";
        }

        query = { combinator: "and", ...query };
      } else query = initialQuery;

    }
    else {
      query = "";
    }

    return query;
  }

  setQuery = querySnap => {
    this.setState({ query: querySnap });

    if (querySnap === initialQuery) {
      this.setState({ fields: [] });
      this.props.onQueryChangeSet("");
    } else
      this.props.onQueryChangeSet(
        JSON.stringify(querySnap, ["rules", "field", "operator", "value"]),
      );
  };

  getDynamicFieldValues(profileFilterList) {
    if (this.isLoadigContinue === Number.MAX_VALUE) this.isLoadigContinue = 0;

    if (!isEmpty(profileFilterList)) {
      const fieldsArr = profileFilterList
        .sort((a, b) =>
          this.props
            .t(a.filterKeyword)
            .localeCompare(this.props.t(b.filterKeyword)),
        )
        .map(value => ({
          name: value.filterKeyword,
          label: this.props.t(value.filterKeyword), //value.name,
          valueEditorType: value.profileFilterFieldType.name,
          values: this.getRuleComboValues(
            value.apiConfigKey,
            value.apiMethodName,
            value.filterKeyword,
            value.userInterfaceData,
          ),
          defaultValue: "",
          placeholder: value.profileFilterFieldType.description,
          operators:
            value.profileFilterFieldType.profileFilterOperatorDefList.map(
              opValue => ({
                name: opValue.operator,
                label: opValue.description,
                multiValueEnabled:
                  opValue.multiValueEnabled === null
                    ? false
                    : opValue.multiValueEnabled,
              }),
            ),
          inputType: value.profileFilterFieldType.inputType
            ? value.profileFilterFieldType.inputType
            : "",
        }));

      this.setState({ fields: fieldsArr });
    }
  }

  getRuleComboValues(
    apiConfigKey,
    apiMethodUrl,
    filterKeyword,
    userInterfaceData,
  ) {
    if (apiConfigKey && apiConfigKey !== "") {
      this.isLoadigContinue = this.isLoadigContinue + 1;

      getRuleValuesFromApi(apiMethodUrl).then(values => {
        this.setDynamicValues(values, filterKeyword, userInterfaceData);
      });

      return [{ name: "0", label: this.props.t("loading") }];
    } else return [];
  }

  setDynamicValues = (apiValues, filterKeyword, userInterfaceData) => {
    const { fields } = this.state;

    const userInterfaceValues = JSON.parse(userInterfaceData);

    const cmbValues = apiValues.map(item => ({
      label: this.getUserIterfaceData(item, userInterfaceValues),
      name: item.guid.toString(),
    }));

    if (fields?.length) {
      fields.forEach(item => {
        if (item && item.name === filterKeyword) {
          item.values = cmbValues;
        }
      });
      this.isLoadigContinue = this.isLoadigContinue - 1;
      this.setState({ fields: fields });
    }
  };

  getUserIterfaceData(item, userInterfaceValues) {
    let userData = "";
    let sep = "";

    if (userInterfaceValues?.fields) {
      if (userInterfaceValues.fields.length >= 2) sep = userInterfaceValues.sep;

      userInterfaceValues.fields.forEach((field, index, array) => {
        userData =
          userData + item[field] + (index + 1 === array.length ? "" : sep);
      });

      return userData;
    } else return this.props.t("InvalidDefinitiom");
  }

  addRule = () => {
    const { query, fields } = this.state;
    let nextField;

    if (fields?.length) {
      nextField = this.isExistQuery(query, fields, nextField);

      if (nextField) {
        const newQuery = add(
          query,
          {
            field: nextField.name,
            operator:
              nextField?.operators?.length
                ? nextField.operators[0].name
                : "",
            value: "",
            valueSources: ["value"],
          },
          [],
        );

        this.setQuery(newQuery);
      }
    }
  };

  isExistQuery = (query, fields, nextField) => {
    if (query?.rules?.length) {
      for (const item of fields) {
        if (query.rules.filter(e => e.field === item.name).length > 0) {
          continue;
        } else {
          nextField = item;
          break;
        }
      }
    } else nextField = fields[0];

    return nextField;
  };

  render() {
    const { profileFilterList } = this.props;
    const transformItems = {
      removeRule: {
        label: (
          <i
            className="mdi mdi-trash-can-outline"
            style={{
              color: "red",
              fontSize: "2em",
              border: 0,
              padding: 0,
              backgroundColor: "inherit",
            }}
          />
        ),
        title: this.props.t("removeRuleTitle"),
      },
      addRule: {
        label: this.props.t("addRuleLabel"),
        title: this.props.t("addRuleTitle"),
      },
    };

    if (
      (!this.profileListReady && isEmpty(profileFilterList)) ||
      this.isLoadigContinue > 0
    ) {
      return this.props.t("loading");
    } else if (this.profileListReady && isEmpty(profileFilterList)) {
      return this.props.t("No rules found");
    }

    return (
      <React.Fragment>
        <Card className="shadow-none border">
          <CardBody className="p-3">
            <div className="ruleGroupContainer">
              <QueryBuilderBootstrap>
                <QueryBuilder
                  // controlClassnames={{
                  //   queryBuilder: "queryBuilder-branches",
                  // }}
                  fields={this.state.fields}
                  translations={transformItems}
                  query={this.state.query}
                  showCombinatorsBetweenRules
                  onQueryChange={querySnap => this.setQuery(querySnap)}
                  disabled={this.props.disabled}
                  controlElements={{
                    addGroupAction: () => null,
                    combinatorSelector: CustomCombinator,
                    addRuleAction: () => null,
                    valueEditor: CustomValueEditor,
                  }}
                />
              </QueryBuilderBootstrap>
              <br />
              <button
                type="button"
                className="ruleGroup-addRule btn btn-sm"
                onClick={this.addRule}
                title={this.props.t("addRuleTitle")}
              >
                {this.props.t("addRuleLabel")}
              </button>
            </div>
          </CardBody>
        </Card>
      </React.Fragment>
    );
  }
}

RavenQueryBuilder.propTypes = {
  profileGroupGuid: PropTypes.number.isRequired,
  initializeQuery: PropTypes.string,
  onQueryChangeSet: PropTypes.func.isRequired,
  profileFilterList: PropTypes.array,
  onGetProfileFilterList: PropTypes.func,
  disabled: PropTypes.bool,
  apiError: PropTypes.any,
  error: PropTypes.any,
  t: PropTypes.any,
};

const mapStateToProps = ({ queryBuilderReducer }) => ({
  profileFilterList: queryBuilderReducer.profileFilterList,
  error: queryBuilderReducer.error,
});

const mapDispatchToProps = dispatch => ({
  onGetProfileFilterList: guid => {
    dispatch(getQueryBuilderProfileFilterListAction(guid));
  },
  apiError: error => dispatch(apiQueryBuilderApiErrorAction(error)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(RavenQueryBuilder));
